import { Form, Formik } from "formik";
import React, { useRef, useState } from "react";
import CustomButton from "../../components/CustomButton";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { toast } from "react-toastify";
import { downloadReportsFun } from "../../../../srcWeb/utils/helpers";

const UserData = () => {
  const [sending, setSending] = useState(false);
  const {apiCall: fileDownload } = useApi();
  const formRef = useRef();


  // const setEnv = () => {
  //   if (process.env.REACT_APP_ENV == "prod") {
  //     return process.env.REACT_APP_API_URL;
  //   } else if (process.env.REACT_APP_ENV == "stag") {
  //     return process.env.REACT_APP_API_URL;
  //   } else {
  //     return process.env.REACT_APP_API_URL;
  //   }
  // };

  // const instance = axios.create({
  //   baseURL: setEnv(), // Add your base URL here
  // });

  // instance.interceptors.request.use(async (config) => {
  //   const accessToken = JSON.parse(getItem("access_token"));
  //   if (accessToken?.access_token) {
  //     config.headers["Authorization"] = "Bearer " + accessToken?.access_token;
  //   }
  //   config.headers["deviceId"] = "1";
  //   return config;
  // });

  const onSubmitRequest = () => {
    setSending(true);

    fileDownload({
      url: apiUrls.sso.downloadAllActiveUsers,
      method: "get",
      responseType: "blob",
      responseData: (res) => {
        const { data = "", status = null } = res || {};
        const contentType = res?.headers?.["content-type"];
        const contentDisposition = res?.headers["content-disposition"];
        const fileNameMatch =
          contentDisposition && contentDisposition.match(/filename="(.+)"/);
        const fileName = fileNameMatch
          ? fileNameMatch[1]
          : "downloaded-file.xlsx";
        if (status === 200) {
          toast.success("Download File Successfully");
          downloadReportsFun(data, "AllActiveUsers.xlsx", contentType);
        } else {
          toast.success("Something Went Wrong");
        }
        setSending(false);
      },
      onFail: (res) => {
        const { data = "", status = null } = res || {};
        const contentType = res?.headers?.["content-type"];
        const contentDisposition = res?.headers["content-disposition"];
        const fileNameMatch =
          contentDisposition && contentDisposition.match(/filename="(.+)"/);
        const fileName = fileNameMatch
          ? fileNameMatch[1]
          : "downloaded-file.xlsx";
        if (status === 200) {
          toast.success("Download File Successfully");
          downloadReportsFun(data, "AllActiveUsers.xlsx", contentType);
        } else {
          toast.success("Something Went Wrong");
        }
        setSending(false);
      }
    })
  };

  return (
    <div className="dashboard-container mt-14">
      <div className="text-[3rem] font-family-medium text-[var(--blackColor)]">User Data</div>
      <Formik
        enableReinitialize
        initialValues={{
          files: "",
        }}
        onSubmit={onSubmitRequest}
        innerRef={formRef}
      >
        {({ errors, touched, values, setFieldValue }) => {
          return (
            <Form>
              <div className="bg-white rounded-[1rem] mt-6 p-8 flex gap-y-4">
                <div className="flex flex-col gap-y-4 w-6/12">
                  <div className="flex items-center justify-between">
                    <span className="me-2 font-size-small">Active Users Report</span>
                    <div style={{ width: "60%" }}>
                      <CustomButton
                        btnClass={"border-none"}
                        // wrapperClassName="!px-8"
                        type="submit"
                        title={sending ? "Downloading..." : "Download"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default UserData;
